module.exports = __webpack_public_path__ + "img/elhcs_cbss.prt.5bea6d12.jpg";